export default {
  loading: "Loading...",
  totalData: "records",
  totalPrefix: "Total",
  startDate: "Start Date",
  endDate: "End Date",
  reset: "Reset",
  search: "Search",
  loadMore: "Load More",
  loadCompleted: "All Loaded",
  collapse: "Collapse",
  noData: "No Data",
  directions: {
    withdraw: "Withdraw",
    deposit: "Deposit",
    buy: "Buy",
    sell: "Sell",
    unknown: "Unknown",
  },
  common: {
    noBank: "No Bank Info Found",
  },
};
